import { render, staticRenderFns } from "./PlaylistItem.vue?vue&type=template&id=4a1bf516&"
import script from "./PlaylistItem.vue?vue&type=script&lang=js&"
export * from "./PlaylistItem.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports